import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import Login from '@/pages/login/Login.vue'
import Home from '@/pages/Home.vue'
import { useLoginStore } from '@/store'
import { DIALOG, SETTINGS, AGENT, EVALUATION } from './constants'
import { ecp } from '@/utils/rangy'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/home',
    component: Home,
    children: [
      {
        path: 'dialog/:historyId?',
        component: () => import('@/pages/dialog/Dialog.vue'),
        name: 'dialog',
        meta: {
          auth: DIALOG
        }
      },
      {
        path: 'history',
        name: 'history',
        component: () => import('@/pages/dialog/HistoryRecord.tsx'),
        meta: {
          auth: DIALOG
        }
      },
      {
        path: 'system-setting',
        component: () => import('@/pages/system-setting/SystemSetting.vue'),
        name: 'system-setting',
        meta: {
          auth: SETTINGS
        }
      },
      {
        path: 'estimate-standard',
        component: () => import('@/pages/agent-setting/EstimateStandard.vue'),
        name: 'estimate-standard',
        meta: {
          auth: AGENT
        }
      },
      {
        path: 'factor-problem',
        component: () => import('@/pages/agent-setting/FactorProblem.vue'),
        name: 'factor-problem',
        meta: {
          auth: AGENT
        }
      },
      {
        path: 'audit',
        component: () => import('@/pages/audit/Audit.vue'),
        name: 'audit',
        meta: {
          auth: EVALUATION,
          keepAlive: true
        }
      },
      {
        path: 'audit-detail/:id',
        component: () => import('@/pages/audit/AuditDetail.vue'),
        name: 'audit-detail',
        meta: {
          auth: EVALUATION,
          notNav: true // 非主页导航栏
        }
      },
      {
        path: '',
        redirect: {
          name: 'dialog'
        },
        name: 'home'
      }
    ]
  },
  {
    path: '/404',
    component: () => import('@/pages/404.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404'
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach(({ meta, path, name }) => {
  const loginStore = useLoginStore()
  const hasAuth =
    !meta.auth || loginStore.permissions.includes(meta.auth as string)
  if (!hasAuth) {
    ecp.utils.message.error('没有权限访问该页面')
    if (loginStore.permissions.length) return false
    return `/login?redirect=${path}`
  }
})

export default router

export { DIALOG, SETTINGS, AGENT, EVALUATION }
